<template>
  <div>
    <div class="white-section">
      <b-form @submit.prevent class="mt-0">
        <b-row>
          <b-col md="4">
            <b-form-group
              :label="$t('settings.duplicateQueueTime')"
              label-for="title"
              :invalid-feedback="
                invalidFeedbackDuration
                  ? $t(`validation.${invalidFeedbackDuration}`, {
                      field: $t('settings.duplicateQueueTime'),
                    })
                  : ''
              "
              :state="$v.duration.$dirty ? !$v.duration.$invalid : null"
            >
              <b-form-input
                autofocus
                id="title"
                dir="ltr"
                placeholder="مدت زمانی که بیمار نمی تواند نوبت تکراری وارد کند را بر حسب دقیقه وارد کنید"
                :state="$v.duration.$dirty ? !$v.duration.$invalid : null"
                v-model="duration"
                v-on:keyup.enter="onEnter"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>

    <div class="white-section mt-2">
      <b-row>
        <div class="col-12 text-right">
          <b-button
            size=""
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="info"
            class=""
            @click="changeDuration"
          >
            {{ $t("general.submit") }}
          </b-button>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BFormInvalidFeedback,
  BBreadcrumb,
} from "bootstrap-vue";
export default {
  mounted() {},
  created() {
    this.setBreadcrumbs([
      { text: "homePage", translate: true, to: { name: "home" } },
      { text: "settings", to: { name: "settings" }, translate: true },
    ]);
    this.setCurrentBreadcrumb([
      { text: "settings", to: { name: "settings" }, translate: true },
    ]);
    this.$store.dispatch("siteSettings/getConfig");
  },
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    BBreadcrumb,
  },
  validations() {
    return {
      duration: {
        required,
      },
    };
  },
  computed: {
    invalidFeedbackDuration: {
      set(error) {},
      get() {
        let error = "";
        if (!this.$v.duration.$dirty) return error;
        if (!this.$v.duration.required) error = "required";
        return error;
      },
    },
    ...mapGetters({
      duration: "siteSettings/duration",
    }),
    duration: {
      set(duration) {
        this.$store.commit("siteSettings/SET_DURATION", duration);
      },
      get() {
        return this.$store.getters["siteSettings/duration"];
      },
    },
  },
  methods: {
    onEnter() {
      this.changeDuration();
    },
    changeDuration() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const payload = {
          notDuplicateTurnMin: Number(this.duration),
        };
        this.$store.commit("SET_IS_LOADING", true);
        this.$store
          .dispatch("siteSettings/getConfig")
          .then((response) => {
            this.$store.commit("SET_IS_LOADING", false);
            if (response) {
              this.$store
                .dispatch("siteSettings/changeDuration", {
                  configId: response._id,
                  payload: payload,
                })
                .then((res) => {
                  if (res) this.$store.dispatch("siteSettings/getConfig");
                });
            } else {
              this.$store
                .dispatch("siteSettings/createDuration", payload)
                .then((res) => {
                  if (res) this.$store.dispatch("siteSettings/getConfig");
                });
            }
            this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
              title: this.$t("toastification.success"),
              variant: "success",
              solid: true,
            });
          })
          .catch((error) => {
            this.$bvToast.toast(msg, {
              title: this.$t("toastification.error"),
              variant: "danger",
              solid: true,
            });
            this.$store.commit("SET_IS_LOADING", false);
          });
      } else {
        this.$nextTick(() => {
          const el = document.querySelector(".is-invalid:first-of-type");
          
          el.scrollIntoView({ behavior: "instant", block: "center" });
          return;
        });
      }
    },
  },
};
</script>
